import { gql } from '@apollo/client';

export const GOVERNING_REPORTING_REQUIREMENTS = gql`
  query governingReportingRequirements($input: GoverningReportingRequirementsInput!) {
    governing: governingReportingRequirements(input: $input) {
      requirementId
      requirementName
      organisationId
    }
  }
`;
